<template>
<div class="table-responsive">
    <table class="table" id="landingPagesComponentsDatas-table">
        <thead>
            <tr>
                <th>Nombre</th>
                <th>Posición</th>
                <th>Mover</th>
                <th>Status</th>
                <th>Acciones</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(footer, index) in datos" :key="index">
                <td>{{ footer.name }}</td>
                <td>{{ footer.position }}</td>
                <td>
                    <div class='btn-group'>
                        <a :disabled="footer.status == 0" v-if="index > 0" :href="'/backend/mantenedor-footer/'+footer.id+'/up'" class='btn btn-default btn-xs'><i class="fa fa-arrow-up"></i></a>
                        <a :disabled="footer.status == 0" v-if="index != (datos.length - 1)" :href="'/backend/mantenedor-footer/'+footer.id+'/down'" class='btn btn-default btn-xs'><i class="fa fa-arrow-down"></i></a>
                    </div>
                </td>
                <td>
                    <el-switch v-model="footer.status" :on-value="1" :off-value="0" :on-text="'SI'" :off-text="'NO'" @change="changeStatus(footer.id)"></el-switch>
                </td>
                <td>
                    <div class='btn-group'>
                        <a :href="'/backend/mantenedor-footer/'+footer.id" class='btn btn-default btn-xs'><i class="fa fa-eye"></i></a>
                        <a :href="'/backend/mantenedor-footer/'+footer.id+'/edit'" class='btn btn-default btn-xs'><i class="fa fa-edit"></i></a>
                        <a  href="" class='btn btn-danger btn-xs' @click.prevent="deleteRegister(footer.id)"><i class="fa fa-trash"></i></a>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
</template>

<script>
import { Message, Confirm } from 'element-ui';
import ElSwitch from 'element-ui/lib/switch';

export default {
    
    props: ['components_lists'],
    components: {
        ElSwitch,
    },

    mounted() {
    },
    
    data() {
        return {
            errors: {},
            datos: this.components_lists
        }
    },

    methods: {
        changeStatus(id) {
            let self = this
            const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            }
            let params = new FormData();
            params.append('id', id);
            axios.post('/backend/footer_desactivate', params, config)
                .then((response) => {
                    window.location.replace(response.data.redirect);
                });
        },
        deleteRegister: function(id) {
            let self = this;
            self.$confirm('¿Está seguro de eliminar el registro?', 'Atención', {
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(() => {
                axios.delete('backend/mantenedor-footer/'+id)
                .then(function(response){
                    window.location.replace(response.data.redirect);
                }).catch(function(error){
                    console.log(error);
                    self.$message.error('Ocurrió un error al intenter eliminar el registro.');
                });                   
            }).catch(() => {
                self.$message({
                    type: 'info',
                    message: 'Eliminación cancelada'
                });
            });
        },
    }
}
</script>

<style>

</style>